import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index.js";
const Dossiers = {
  namespaced: true,
  state: {
    dossiers: [],
    features: [],
    managers: [],
    reception: {},
    point: [],
    foldersNumber: null,
    dossierSelected: {
      wayType: null,
      isAccessDevelopment: null,
      type: null,
      wayNum: null,
      adresses: [],
      milestoneStart1: null,
      milestoneStart2: null,
      milestoneEnd1: null,
      milestoneEnd2: null,
      extraUrban: true,
      isFavorable: null,
      intraUrban: true,
      inUrban: null,
      urbanDocument: null,
      sections: null,
      plotNumbers: null,
      project: null,
      numaffaire: null,
      reference: null,
      place: null,
      dateStart: null,
      numberDays: null,
      sendToSign: null,
      petitionerId: null,
      cerfa1402301Id: null,
      alignementId: null,
      beneficiaryId: null,
      addressCity: null,
      addressExt: null,
      addressName: null,
      addressNum: null,
      addressPostalCode: null,
      addressType: null,
      lat: null,
      lon: null,
      operationCode: null,
      caseNumbers: null,
      theGeom: null,
      instructeurId: null,
      extensionid: null,
      noMail: null,
      mailArreteSignes: [],
      cerfa1402301: {},
    },
    pagination: {
      current: 1,
      totalCount: 1,
      numItemsPerPage: 50,
    },
    urlOpenDoc: null,
    typesDocs: [],
  },
  actions: {
    addDossier(context, request) {
      return Vue.axios
        .post(window.urlapi + "request", request, { timeout: 20000 })
        .then((response) => {
          if (response.data.success) {
            return response.data.data;
          } else {
            throw new Error(response.data.message || "Erreur serveur lors de la création du dossier.");
          }
        })
        .catch((error) => {
          console.error("Erreur dans addDossier:", error);
          throw error;
        });
    },

    setDossier(context, request) {
      return new Promise((resolve, reject) => {
        request.isFavorable = null;
        context.commit("SETDOSSIER", request);
        resolve();
      });
    },
    initDossier(context) {
      return new Promise((resolve, reject) => {
        let request = {
          wayType: null,
          type: null,
          adresses: [],
          wayNum: null,
          isAccessDevelopment: null,
          milestoneStart1: null,
          milestoneStart2: null,
          milestoneEnd1: null,
          milestoneEnd2: null,
          extraUrban: true,
          isFavorable: null,
          intraUrban: true,
          inUrban: null,
          urbanDocument: null,
          sections: null,
          plotNumbers: null,
          project: null,
          numaffaire: null,
          reference: null,
          place: null,
          dateStart: null,
          numberDays: null,
          sendToSign: null,
          petitionerId: null,
          cerfa1402301Id: null,
          alignementId: null,
          beneficiaryId: null,
          addressCity: null,
          addressExt: null,
          addressName: null,
          addressNum: null,
          addressPostalCode: null,
          addressType: null,
          lat: null,
          lon: null,
          operationCode: null,
          caseNumbers: null,
          noMail: null,
          mailArreteSignes: [],
          theGeom: null,
          instructeurId: null,
          extensionid: null,
        };
        context.commit("SETDOSSIER", request);
        resolve();
      });
    },
    getDossiers(context, pagination) {
      let page = "?page=" + pagination.page;
      let type = "&type=" + pagination.type;
      let numItemsPerPage = "&numItemsPerPage=" + pagination.numItemsPerPage;

      let searchText = "&searchText=" + pagination.searchText;
      let searchFilter =
        "&searchFilter=" + JSON.stringify(pagination.searchFilter);

      let searchSort = "&searchSort=" + pagination.searchSort;
      let searchDir = "&searchDir=" + pagination.searchDir;

      Vue.axios
        .get(
          window.urlapi +
            "request" +
            page +
            type +
            numItemsPerPage +
            searchText +
            searchFilter +
            searchSort +
            searchDir
        )
        .then((response) => {
          context.commit("GETDOSSIERS", response.data.data);
          context.commit("GETFEATURES", response.data.features);
          context.commit("SETPAGINATION", response.data.pagination);
        });
    },
    addReception(context, data) {
      const skipGlobalSpinner = data.skipGlobalSpinner === true;
      const payload = { ...data };
      delete payload.skipGlobalSpinner;

      return Vue.axios
        .post(window.urlapi + "reception", payload, { skipGlobalSpinner })
        .then((response) => {
        if (response.data.success == true) {
          context.commit("GETRECEPTION", response.data.data.reception);
          context.commit("GETDOSSIER", response.data.data.request);
          Vue.prototype.$awn.info(response.data.message.toString());
          return response.data.data;
        }
        throw new Error(
          response.data.message || "Erreur lors de l'ajout de la réception."
        );
      });
    },
    getReception(context, payload) {
      const id = typeof payload === "object" ? payload.id : payload;
      const skipGlobalSpinner =
        typeof payload === "object" && payload.skipGlobalSpinner === true;

      return Vue.axios
        .get(window.urlapi + "reception/" + id, { skipGlobalSpinner })
        .then((response) => {
        if (response.data.success == true) {
          context.commit("GETRECEPTION", response.data.data);
          return true;
        }
        context.commit("GETRECEPTION", {});
        return false;
      });
    },
    updateReception(context, data) {
      const skipGlobalSpinner = data.skipGlobalSpinner === true;
      const payload = { ...data };
      delete payload.skipGlobalSpinner;

      return Vue.axios
        .put(window.urlapi + "reception", payload, { skipGlobalSpinner })
        .then((response) => {
        if (response.data.success == true) {
          context.commit("GETRECEPTION", response.data.data.reception);
          context.commit("GETDOSSIER", response.data.data.request);
          return response.data.data;
        }
        throw new Error(
          response.data.message || "Erreur lors de la mise à jour de la réception."
        );
      });
    },
    countDossiers(context, payload = {}) {
      // paramètres facultatifs
      const type = payload.type ? "&type=" + payload.type : "";
      const searchText = payload.searchText ? "&searchText=" + payload.searchText : "";
      const searchFilter = payload.searchFilter
        ? "&searchFilter=" + JSON.stringify(payload.searchFilter)
        : "";
    
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(window.urlapi + "request/count?" + type + searchText + searchFilter)
          .then((response) => {
            if (response.data.success === true) {
              context.commit("GETFOLDERSNUMBER", response.data.data);
              resolve(response.data.data);
            } else {
              resolve(null);
            }
          })
          .catch((error) => {
            console.error("Erreur lors du comptage :", error);
            reject(error);
          });
      });
    },    
    initPoint(context) {
      return new Promise((resolve, reject) => {
        let firstAddress = {
          geometry: {
            type: "Point",
            coordinates: [-1.3160444, 43.6618506],
          },
          type: "Feature",
          properties: {},
        };
        context.commit("GETPOINT", firstAddress);
        resolve();
      });
    },
    getDossier(context, payload) {
      const id = typeof payload === "object" ? payload.id : payload;
      const skipGlobalSpinner =
        typeof payload === "object" && payload.skipGlobalSpinner === true;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(window.urlapi + "request/" + id, { skipGlobalSpinner })
          .then((response) => {
          response.data.data.point = response.data.extra;
          response.data.data.type = [];
          if (response.data.data.cerfa1402301 != null) {
            response.data.data.type.push("cerfa14023");
          }
          if (response.data.data.alignement != null) {
            response.data.data.type.push("alignement");
          }
          context.commit("GETDOSSIER", response.data.data);
          context.commit("GETFEATURES", response.data.features);
          context.commit("GETPOINT", response.data.extra);
          resolve();
        });
      });
    },
    updateDossier(context, dossier) {
      const skipGlobalSpinner = dossier.skipGlobalSpinner === true;
      const payload = { ...dossier };
      delete payload.skipGlobalSpinner;

      return Vue.axios
        .put(window.urlapi + "request/" + payload.id, payload, { skipGlobalSpinner })
        .then((response) => {
          if (response.data.success) {
            Vue.prototype.$awn.success(response.data.message.toString());
            context.commit("GETDOSSIER", response.data.data);
            return response.data.data;
          } else {
            throw new Error(response.data.message || "Erreur lors de la mise à jour du dossier.");
          }
        })
        .catch((error) => {
          console.error("Erreur dans updateDossier:", error);
          throw error; 
        });
    },
    extension(context, dossier) {
      return new Promise((resolve) => {
        Vue.axios
          .post(window.urlapi + "request/extension/" + dossier.id, dossier)
          .then((response) => {
            if (response.data.success == true) {
              Vue.prototype.$awn.success(response.data.message.toString());
              resolve();
              router.push({ name: "Dossiers" });
            }
          });
      });
    },
    getManagers(context, id) {
      Vue.axios
        .get(window.urlapi + "request/" + id + "/managers")
        .then((response) => {
          context.commit("GETMANAGERS", response.data.data);
        });
    },
    setDossier(context, pagination) {
      context.commit("SETPAGINATION", pagination);
    },
    setReception(context, reception) {
      context.commit("GETRECEPTION", reception);
    },
    startMerge(context, data) {
      return new Promise((resolve) => {
        Vue.axios.post(window.urlapi + "mergearrete", data)
        .then((response) => {
          let url = window.urlapi + 'onlyoffice/' + response.data.data;

          fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
          resolve(response);
        });
      });
    },
    //data contient le type de demande 1 = voirie, 2 = alignement ou 3 = acces
    sendToClicmap(context, id) {
      Vue.axios
        .post(window.urlapi + "request/sendClicmap/" + id)
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
          } else {
            Vue.prototype.$awn.error(response.data.message.toString());
          }
        });
    },
    deleteDossier(context, id) {
      Vue.axios.delete(window.urlapi + "request/" + id).then((response) => {
        if (response.data.success == true) {
          Vue.prototype.$awn.success(response.data.message.toString());

          context.commit("DELETEREQUEST", id);
        }
      });
    },
  },
  mutations: {
    SETURLOPENDOC: (state, urlOpenDoc) => {
      state.urlOpenDoc = urlOpenDoc;
    },
    SETDOSSIER: (state, dossier) => {
      state.dossierSelected = dossier;
    },
    SETPAGINATION: (state, pagination) => {
      state.pagination = pagination;
    },
    GETFOLDERSNUMBER(state, foldersNumber) {
      state.foldersNumber = foldersNumber;
    },
    GETRECEPTION(state, reception) {
      state.reception = reception;
    },
    GETDOSSIERS: (state, dossiers) => {
      state.dossiers = dossiers;
    },
    GETPOINT: (state, point) => {
      state.point = Object.freeze(point);
    },
    GETFEATURES: (state, features) => {
      state.features = Object.freeze(features);
    },
    DELETEREQUEST: (state, id) => {
      let toDelete = state.dossiers.findIndex((item) => item.state.id === id);
      state.dossiers.splice(toDelete, 1);
    },
    GETDOSSIER: (state, dossier) => {
      dossier.stateId = dossier.state.id;
      state.dossierSelected = dossier;
    },
    GETMANAGERS: (state, managers) => {
      state.managers = managers;
    },
  },
  getters: {
    urlOpenDoc: (state) => {
      return state.urlOpenDoc;
    },
    pagination: (state) => {
      return state.pagination;
    },
    point: (state) => {
      return state.point;
    },
    dossiers: (state) => {
      return state.dossiers || [];
    },
    reception: (state) => {
      return state.reception;
    },
    features: (state) => {
      return state.features;
    },
    countdossiers: (state) => {
      return state.dossier.length;
    },
    foldersNumber: (state) => {
      return state.foldersNumber;
    },
    dossierSelected: (state) => {
      return state.dossierSelected;
    },
    managers: (state) => {
      return state.managers;
    },
    typesDocs: (state) => {
      return state.typesDocs || [];
    },
  },
  modules: {},
};

export default Dossiers;
